/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemTextInputFormatTextBoxBase } from './formPagePropertyItemTextInputFormatTextBoxBase';
import { FormPagePropertyItemZipCodeSearchSetting } from './formPagePropertyItemZipCodeSearchSetting';


export interface FormPagePropertyItemTextInputFormatZipCodeAllOf { 
    first: FormPagePropertyItemTextInputFormatTextBoxBase;
    second: FormPagePropertyItemTextInputFormatTextBoxBase;
    /**
     * 郵便番号の各入力枠の区切り文字
     */
    delimiter: FormPagePropertyItemTextInputFormatZipCodeAllOf.DelimiterEnum;
    searchSetting?: FormPagePropertyItemZipCodeSearchSetting;
}
export namespace FormPagePropertyItemTextInputFormatZipCodeAllOf {
    export type DelimiterEnum = '-';
    export const DelimiterEnum = {
        Hyphen: '-' as DelimiterEnum
    };
}



